"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActiveFiltersPanel = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const AdaptableContext_1 = require("../AdaptableContext");
const ModuleConstants = tslib_1.__importStar(require("../../Utilities/Constants/ModuleConstants"));
const AdaptableObjectCompactList_1 = require("../Components/AdaptableObjectList/AdaptableObjectCompactList");
const ActiveFiltersPanel = () => {
    const adaptable = (0, AdaptableContext_1.useAdaptable)();
    const filterModule = adaptable.ModuleService.getModuleById(ModuleConstants.ColumnFilterModuleId);
    const columnFilters = adaptable.api.columnFilterApi.getColumnFilters();
    return React.createElement(AdaptableObjectCompactList_1.AdaptableObjectCompactList, { abObjects: columnFilters, module: filterModule });
};
exports.ActiveFiltersPanel = ActiveFiltersPanel;
